export default __webpack_public_path__ + "static/media/int_redshift.ba2c15d1.svg";